import constants from '../constants.js';
import {
    Id,
    FlightFareClasses,
    FlightFareBucketClassesGrid,
    LimitCountries,
    ItineraryValidatorSettings,
    BookingThreshold,
    ErrorMessagesGrid,
    DefaultFareRules,
    FlightFareDataGrid,
    TermsAndConditionsGrid,
    VehicleDefaultsGrid,
    VehicleEmissionsGrid,
    IsFlightSearchUniversalProductAttributesTabEnabled,
    FlightSearchUniversalProductAttributesTabLabel,
    IsFlightSearchUniversalProductAttributesShortcutEnabled,
    FlightSearchUniversalProductAttributesShortcutLabel,
    EnableNewUiSystemSetting,
    ApprovalPanel,
    AdditionalPnrRemarksPanel,
    GuestTravellersTitlesPanel,
    PnrFinishingRemarksPanel,
    SettingsGDSPanel,
    CountryPnrFinishingRemarksGrid,
    SalesAgentsPanel,
    HotelPanel,
    RailPanel,
    FlightPanel,
    PerDiemPanel,
    ConfigReportPanel,
    UnusedTicketPanel,
    DatetimeFormatPanel,
    NamedListsPanel,
    CreditCardMappingsPanel,
    CountryAirlinesPanel
} from '../fields/settingsResource.js';

const Disabled = {
  displayName: "DISABLED",
  dataAt: "Disabled",
  displayAs: constants.DISPLAY_AS.BOOLEAN,
};

const IsDefault = {
  displayName: 'Default Settings',
  dataAt: 'IsDefault',
  displayAs: constants.DISPLAY_AS.SELECT,
  optionsAt: 'BoolNullableType',
  defaultValue: "false",
  handleAsString: true,
  allowNullable: false,
  hideShowProperty: 'IsDefault',
  helpText:
    "Only 1 Settings should be set as default. If set, this will be the default Settings that is returned if there is no matching Settings for a debtor's Home Country Code.",
};

const CountryCodes = {
  displayName: 'Debtor Home Country Codes',
  dataAt: 'CountryCodes',
  displayAs: constants.DISPLAY_AS.TAG_INPUT,
  formClass: 'IsDefault_false',
  helpText:
    "Requires at least one Country Code if is not Default Settings. If blank, saving will fail.",
};

const GlobalSettingsMiscPanel = {
  tabName: "Settings-Misc",
  dataAt: "",
  displayAs: constants.DISPLAY_AS.GROUP,
  children: [
    Id,
    Disabled,
    IsDefault,
    CountryCodes,
    FlightFareClasses,
    FlightFareBucketClassesGrid,
    LimitCountries,
    ItineraryValidatorSettings,
    BookingThreshold,
    ErrorMessagesGrid,
    DefaultFareRules,
    FlightFareDataGrid,
    TermsAndConditionsGrid,
    VehicleDefaultsGrid,
    VehicleEmissionsGrid,
    IsFlightSearchUniversalProductAttributesTabEnabled,
    FlightSearchUniversalProductAttributesTabLabel,
    IsFlightSearchUniversalProductAttributesShortcutEnabled,
    FlightSearchUniversalProductAttributesShortcutLabel,
    EnableNewUiSystemSetting,
  ],
};

const GlobalSettingsTabs = {
  displayName: "Settings",
  iconClass: "fa-cog",
  displayAs: constants.DISPLAY_AS.TABS,
  children: [
    GlobalSettingsMiscPanel,
    ApprovalPanel,
    AdditionalPnrRemarksPanel,
    GuestTravellersTitlesPanel,
    PnrFinishingRemarksPanel,
    SettingsGDSPanel,
    CountryPnrFinishingRemarksGrid,
    SalesAgentsPanel,
    HotelPanel,
    RailPanel,
    FlightPanel,
    PerDiemPanel,
    ConfigReportPanel,
    UnusedTicketPanel,
    DatetimeFormatPanel,
    NamedListsPanel,
    CreditCardMappingsPanel,
    CountryAirlinesPanel
  ],
};

const GlobalSettingsAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: "Global Settings",
  data: {
    IsDefault: false,
    CountryCodes: []
  },
  children: [IsDefault, CountryCodes],
  endpoint: "GlobalSettings",
};

const GlobalSettingsResource = {
  displayName: 'Settings',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '',
  iconClass: 'fa-cog',
  children: [GlobalSettingsTabs],
  endpoint: 'GlobalSettings',
  routeParamId: 'settingsId',
};

const GlobalSettingsList = {
  rootNode: true,
  displayName: 'Global Settings',
  endpoint: 'GlobalSettings',
  ODataArgs: '?$select=Id,IsDefault,CountryCodes,Disabled',
  displayAs: constants.DISPLAY_AS.GRID,
  gridItem: GlobalSettingsResource,
  gridAdd: GlobalSettingsAddResource,
  canCopyResource: true,
  copyWithoutCopyText: true,
  canFilterDisabled: true,
  disableProperty: 'Disabled',
  iconClass: 'fa-cog',
  gridCols: [
    { name: 'Default Settings', key: 'IsDefault' },
    { name: 'Debtor Home Country Codes', key: 'CountryCodes' },
    { name: 'Disabled', key: 'Disabled' }
  ],
};

export default {
  GlobalSettingsList,
  GlobalSettingsResource,
  GlobalSettingsAddResource,
  GlobalSettingsTabs,
  GlobalSettingsMiscPanel,
  Disabled,
  IsDefault,
  CountryCodes
};



// WEBPACK FOOTER //
// ./src/config/fields/globalSettingsResource.js